module.exports = __webpack_public_path__ + "img/cirrus.88abcdb7.png";